// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3MVp1","content":"Consent_content__3NiIK","footer":"Consent_footer__2C7Hi"};